module.exports = "<h1 mat-dialog-title style=\"text-align: center;\">Your Session Has Expired </h1>\r\n\r\n<div mat-dialog-actions style=\"justify-content: center;\">\r\n  <button mat-button mat-button mat-dialog-close (click)=\"logout()\">Logout</button>\r\n  <button mat-button (click)=\"restart()\" cdkFocusInitial>Stay</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/expired-dialog-box.html
// module id = ./src/app/login/expired-dialog-box.html
// module chunks = main